































import {Vue, Component, Prop, Inject, Watch} from 'vue-property-decorator';
import {API_BIS_PATENT_CLEAN, API_BIS_PATENT_CLEANDATALIST} from "@/configs/Apis";
import {isEmptyOrWhiteSpace} from "@/utils/Common";
import {showConfirm, showSuccess, showWarning} from "@/utils/UI";

@Component
export default class DataClean extends Vue {
    @Prop({type: Boolean, default: () => false})
    visible!: boolean;

    changed: boolean = false;

    selectedItems: Array<any> = [];

    dataItems: Array<{ name: string }> = [];

    condition: any = {
        textField: "applicant",
        cleanValue: "",
        keyWord: ""
    };

    recordCount: number = 0;

    pageSize: number = 20;

    pageIndex = 0;

    @Inject()
    projectId!: string;

    created() {
        this.$nextTick(() => this.loadCleanDataList());
    }

    loadCleanDataList() {
        const queryParams = {
            fieldName: this.condition.textField,
            page: this.pageIndex - 1,
            pageSize: this.pageSize,
            keyWord: this.condition.keyWord
        };
        this.$http.post<{ count: number, data: Array<any> }>({url: API_BIS_PATENT_CLEANDATALIST, path: {projectId: this.projectId}}, queryParams).then((entity) => {
            this.recordCount = entity.count;
            this.dataItems = (entity.data || []).map(item => Object.assign(item, {rowKey: item.name + item.newName + item.count}));
        });
    }

    get textFields() {
        return [
            {name: "applicant", label: "申请人"},
            {name: "inventor", label: "发明人"}
        ]
    }

    doCleanData() {
        if (!this.selectedItems || !this.selectedItems.length) {
            showWarning("请选择要修改的数据项");
            return;
        }

        showConfirm("是否修改选中的数据").then(() => {
            this.$http.post({url: API_BIS_PATENT_CLEAN, path: {projectId: this.projectId}}, {fieldName: this.condition.textField, newValue: this.condition.cleanValue, oldValue: this.selectedItems.map(item => item.name)}).then(() => {
                showSuccess("保存成功");
                this.loadCleanDataList();
                this.changed = true;
                (this.$refs.dataTable as any).clearSelection();
            });
        });
    }

    closeDialog() {
        this.$emit("update:visible", false);
        if (this.changed) {
            this.$emit("data-changed");
        }
    }

    onSelectionChange(seletedItems: Array<any>) {
        this.selectedItems = seletedItems;
    }

    onFieldNameChange() {
        this.selectedItems = [];
        (this.$refs.dataTable as any).clearSelection();
        this.onKeyWordChanged();
    }

    @Watch("pageIndex")
    onTextFieldChanged() {
        this.loadCleanDataList();
    }

    @Watch("pageSize")
    onKeyWordChanged() {
        if (this.pageIndex === 1) {
            this.loadCleanDataList();
        } else {
            this.pageIndex = 1;
        }
    }
}
